import { StatisticsClientService } from '@services/api/statistics/statistics-client.service';
import { HardCodedConfigService } from '@services/util/hard-coded-config.service';
import { addDays, format } from 'date-fns';
import { map, Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';

export interface TodaysMetrics {
  checkins: {
    completed: number;
    total: number;
  };
  checkouts: {
    completed: number;
    total: number;
  };
  cleaning: {
    completed: number;
    total: number;
  };
  expedia: number;
}

@Injectable({
  providedIn: 'root'
})
export class DashboardDataService {
  private readonly statisticsClientService = inject(StatisticsClientService);
  private readonly config = inject(HardCodedConfigService);

  getTodaysMetrics(): Observable<TodaysMetrics> {
    const today = format(new Date(), 'yyyy-MM-dd');
    return this.statisticsClientService.getDailyActivities(today).pipe(
      map((resp) => ({
        checkins: { completed: resp.checkin_completed, total: resp.checkin_expected },
        checkouts: { completed: resp.checkout_completed, total: resp.checkout_expected },
        cleaning: { completed: resp.cleaning_completed, total: resp.cleaning_scheduled },
        expedia: resp.expedia_bookings
      }))
    );
  }

  // Backend requires a date range; we want near-global totals, so we pass the system go-live
  // date as the lower bound. end is exclusive, hence today + 1 to include today.
  getIssueOverview(): Observable<{ total: number; open: number; inProgress: number }> {
    const start = this.config.STATISTICS_ALL_TIME_START_DATE;
    const end = format(addDays(new Date(), 1), 'yyyy-MM-dd');
    return this.statisticsClientService.getIssueOverview(start, end).pipe(
      map((resp) => ({ total: resp.total_issues, open: resp.open_issues, inProgress: resp.in_progress_issues }))
    );
  }
}
